var _path, _linearGradient, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcaIconDarkactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#485CC7",
    d: "M50 0C22.384 0 0 22.388 0 50c0 .279.016.553.021.829l48.718 2.079-19.587 42.537A49.782 49.782 0 0050 99.999c27.609 0 50-22.384 50-49.999 0-27.612-22.391-50-50-50z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: -683.455,
    y1: 623.764,
    x2: -650.189,
    y2: 657.029,
    gradientTransform: "matrix(1 0 0 -1 694 705)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5c39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#485cc7"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M22.418 37.705L.021 50.829c.323 19.815 12.168 36.819 29.132 44.616L48.74 83.973V52.9L22.418 37.705z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.418 37.705l26.321 15.203v31.065L93.52 25.337z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcaIconDarkactive);
export default __webpack_public_path__ + "static/media/proca-icon-darkactive.810c1fbd.svg";
export { ForwardRef as ReactComponent };